import { useRecipesQuery } from "@/pages/sy/hooks/queries/useRecipesQuery";
import { ErrorModal } from "@dexteel/mesf-core";
import { useState } from "react";
import { CircularProgress, TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import type { FieldError } from "react-hook-form";

interface Props {
  label: string;
  value: number | null;
  onChange?: (value: number | null) => void;
  fieldError?: FieldError | undefined;
  disabled?: boolean;
}

export const RecipeAutocomplete = ({
  label,
  value,
  onChange = () => {},
  fieldError,
  disabled = false,
}: Props) => {
  const [error, setError] = useState("");
  const { data: recipes = [], isLoading } = useRecipesQuery(true, true, (err) =>
    setError(err.message),
  );

  const selectedValue = recipes.find((r) => r.RecipeId === value) || null;

  return (
    <>
      <Autocomplete
        id="recipe-autocomplete"
        options={recipes ?? []}
        getOptionLabel={(option) => option.RecipeName}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            fullWidth
            size="small"
            error={!!fieldError}
            helperText={fieldError?.message}
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <>
                    {isLoading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : (
                      params.InputProps.endAdornment
                    )}
                  </>
                ),
              },
            }}
          />
        )}
        value={selectedValue}
        onChange={(_, newValue) => {
          onChange(
            newValue && typeof newValue.RecipeId === "number"
              ? newValue.RecipeId
              : null,
          );
        }}
        disabled={disabled}
      />
      <ErrorModal
        error={error}
        onHide={() => setError("")}
        title="Error loading recipes"
      />
    </>
  );
};
